import { getExpoData } from "@/_core/data/api_calls/getExpoData";
import { getHedgeData } from "@/_core/data/api_calls/getHedgeData";
import { getExpoDataCommodities } from "@/_core/data/api_calls/getExpoDataCommodities";
import { getHedgeDataCommodities } from "@/_core/data/api_calls/getHedgeDataCommodities";
import { saveUserPreferences } from "@/_core/data/SaveToDB";
import { sortByKey } from "@/_core/_helpers/_helpers.js";

export function setDefaultItems(opt, _this) {
  if (_this.selectedNavAsset === 0) {
    _this.defaultItemExpo.fk_idcurrency = opt[0].name;
    _this.defaultItemHedge.fk_idcurrency = opt[0].name;
    _this.defaultItemExpo.fk_idcountry_currency = _this.defaultItemExpo.fk_idcurrency.slice(
      0,
      3
    );
    _this.defaultItemHedge.fk_idcountry_currency = _this.defaultItemHedge.fk_idcurrency.slice(
      0,
      3
    );
    _this.defaultItemHedge.fk_idcountry_premium_currency = _this.defaultItemHedge.fk_idcurrency.slice(
      3,
      6
    );
    _this.leftRightCurrExpo = [
      _this.defaultItemExpo.fk_idcurrency.slice(0, 3),
      _this.defaultItemExpo.fk_idcurrency.slice(3, 6)
    ];
    _this.leftRightCurrHedge = [
      _this.defaultItemHedge.fk_idcurrency.slice(0, 3),
      _this.defaultItemHedge.fk_idcurrency.slice(3, 6)
    ];
  } else {
    _this.defaultItemExpoCommodities.fk_idcommodity = opt[0].name;
  }
}

export function getPortfolios(_this) {
  // On company change, populate portfolios for this company
  let opt = [];
  let port;
  if (_this.companies.length === 0) {
    port = [];
  } else if (_this.companies.length > 0) {
    port = _this.companies[_this.selectedCompany].portfolios;
  } else {
    port = _this.companies[0].portfolios;
  }
  for (let i = 0; i < port.length; i++) {
    if (port[i].fk_currency.length > 0) {
      opt.push({
        id: i,
        pk: port[i].pk_idportfolio,
        name: port[i].portfolio_name,
        currency: port[i].fk_currency,
        commodity: port[i].fk_idcommodity
      });
    }
  }
  opt = sortByKey(opt, "name");
  return opt.filter(_this.processData.onlyUnique);
}

export function getPortfoliosCommodities(_this) {
  // On company change, populate portfolios for this company
  let opt = [];
  let port;
  if (_this.companies.length === 0) {
    port = [];
  } else if (_this.companies.length > 0) {
    port = _this.companies[_this.selectedCompany].portfolios;
  } else {
    port = _this.companies[0].portfolios;
  }
  for (let i = 0; i < port.length; i++) {
    if (port[i].fk_idcommodity.length > 0) {
      opt.push({
        id: i,
        pk: port[i].pk_idportfolio,
        name: port[i].portfolio_name,
        currency: port[i].fk_currency,
        commodity: port[i].fk_idcommodity
      });
    }
  }
  opt = sortByKey(opt, "name");
  return opt.filter(_this.processData.onlyUnique);
}

export function getCurrencies(_this) {
  let opt = [];
  let all_currencies = _this.$store.state.currencies.all.items;
  let element, doSearch;
  if (_this.selectedPortfolios.length > 0) {
    for (let i = 0; i < _this.selectedPortfolios.length; i++) {
      for (let j = 0; j < _this.selectedPortfolios[i].currency.length; j++) {
        const name = _this.selectedPortfolios[i].currency[j];
        element = all_currencies.find(d => d.currency_name === name);
        const pk = element ? element.pk_i_idcurrency : null;
        // The same currency can live in several selected portfolios. A
        // duplicate is the same pk AND the same name: keep only the first.
        doSearch = !opt.some(d => d.pk === pk && d.name === name);
        if (doSearch) {
          opt.push({ id: j, name, pk });
        }
      }
    }
  } else {
    opt = _this.portfolios[0].commodity;
  }
  opt = sortByKey(opt, "name");
  opt = opt.filter(_this.processData.onlyUnique);
  // Re-index so callers that look up by `.id` map to this list's positions.
  opt.forEach((d, i) => {
    if (d && typeof d === "object") d.id = i;
  });
  if (opt.length > 0) {
    setDefaultItems(opt, _this);
  }
  return opt;
}
export function getCommodities(_this) {
  let opt = [];
  let all_commodities = _this.$store.state.commodities.all.items;
  let element, doSearch;
  if (_this.selectedPortfolios.length > 0) {
    if (_this.selectedPortfolios[0] === undefined) {
      return null;
    }
    for (let i = 0; i < _this.selectedPortfolios.length; i++) {
      for (let j = 0; j < _this.selectedPortfolios[i].commodity.length; j++) {
        // Names are normalised to upper-case; compare against the same casing
        // so shared commodities across portfolios are detected as duplicates.
        const name = _this.selectedPortfolios[i].commodity[j].toUpperCase();
        element = all_commodities.find(
          d => d.fk_idproduct.toUpperCase() === name
        );
        const pk = element ? element.pk_idcommodity : null;
        // A duplicate is the same pk AND the same name: keep only the first.
        doSearch = !opt.some(d => d.pk === pk && d.name === name);
        if (doSearch) {
          opt.push({ id: j, name, pk });
        }
      }
    }
  } else {
    opt = _this.portfolios[0].commodity;
  }
  opt = sortByKey(opt, "name");
  opt = opt.filter(_this.processData.onlyUnique);
  // Re-index so callers that look up by `.id` map to this list's positions.
  opt.forEach((d, i) => {
    if (d && typeof d === "object") d.id = i;
  });
  if (opt.length > 0) {
    setDefaultItems(opt, _this);
  }
  return opt;
}

export function companyPortfolioAsset(
  _this,
  step = 0,
  resetPortfolio,
  fetch = true
) {
  if (_this.selectedNavAsset === 0) {
    _this.expo = [];
    _this.hedge = [];
  } else {
    _this.expoCommodities = [];
    _this.hedgeCommodities = [];
  }
  resetPortfolio = true;
  // ============ Company Changed ============
  if (step === 0) {
    let portAux;
    if (_this.selectedNavAsset === 0) {
      portAux = getPortfolios(_this);
    } else {
      portAux = getPortfoliosCommodities(_this);
    }
    _this.portfolios = [];
    portAux.forEach(function(d, i) {
      _this.portfolios.splice(i, 0, d);
    });
    if (resetPortfolio) {
      _this.selectedPortfolios = [];
      _this.datamodel_preferences.selected_portfolio = [];
      _this.selectedPortfolios.push(_this.portfolios[0]);
      _this.datamodel_preferences.selected_portfolio.push(_this.portfolios[0]);
      _this.prevSelectedPortfolios = _this.selectedPortfolios;
    }
  }
  // ============ Portfolio Changed ============
  if (step <= 1) {
    if (_this.selectedNavAsset === 0) {
      _this.currencies = [];
      let currAux = getCurrencies(_this);
      currAux.forEach(function(d, i) {
        _this.currencies.splice(i, 0, d);
      });
      if (resetPortfolio) {
        _this.defaultItemExpo.fk_idportafolio = _this.portfolios[0].name;
        _this.defaultItemHedge.fk_idportafolio = _this.portfolios[0].name;
        _this.selectedCurrency = [];
        _this.selectedCurrency.push(_this.currencies[0]);
        _this.prevSelectedCurrency = _this.selectedCurrency;
      }

      try {
        setDefaultItems(_this.selectedCurrency, _this);
      } catch (error) {
        console.log("Default items not set", error);
      }
      _this.currencyString = _this.currencies[0].name;
    } else {
      _this.commodities = [];
      let commAux = getCommodities(_this);
      if (commAux == null) {
        return null;
      }
      commAux.forEach(function(d, i) {
        _this.commodities.splice(i, 0, d);
      });
      if (resetPortfolio) {
        _this.defaultItemExpoCommodities.fk_idportafolio =
          _this.portfolios[0].name;
        _this.defaultItemHedgeCommodities.fk_idportafolio =
          _this.portfolios[0].name;
        _this.selectedCommodity = [];
        _this.selectedCommodity.push(_this.commodities[0]);
        _this.prevSelectedCommodity = _this.selectedCommodity;
      }

      try {
        setDefaultItems(_this.selectedCommodity, _this);
      } catch (error) {
        console.log("Default items not set", error);
      }
    }
  }
  if (_this.selectedNavAsset === 1) {
    _this.commodityString = _this.commodities[_this.selectedCommodity[0].id];
    _this.allCommodities.forEach(function(d) {
      if (
        d.fk_idproduct.toUpperCase() ===
        _this.commodityString.name.toUpperCase()
      ) {
        _this.defaultItemExpoCommodities.commodity_unit = d.fk_idunit;
      }
    });
  }
  // ============ Asset changed & API calls ============
  if (fetch) {
    _this.dataLoadToken = (_this.dataLoadToken || 0) + 1;
    if (_this.selectedNavAsset === 0) {
      _this.showLoadingExpo = true;
      _this.showLoadingHedge = true;
      getExpoData(_this);
      _this.refresh = _this.user.clean_cache;
      getHedgeData(_this);
    } else {
      _this.showLoadingExpoCommodities = true;
      _this.showLoadingComHedge = true;
      getExpoDataCommodities(_this);
      _this.refresh = _this.user.clean_cache;
      getHedgeDataCommodities(_this);
    }
  }
  if (_this.selectedSheet === 2) {
    _this.watcherCompanySelected += 1;
  }
}

export function setManagementInfo(
  _this,
  step = 0,
  resetPortfolio = true,
  fetch = true
) {
  _this.showLoadingExpo = true;
  _this.showLoadingHedge = true;
  // CRUD: initiate default Expo item
  _this.defaultItemExpo.fk_idcurrency = _this.allCurrencies[0].currency_name;
  _this.defaultItemExpo.fk_idcountry_currency = _this.defaultItemExpo.fk_idcurrency.slice(
    0,
    3
  );
  _this.leftRightCurrExpo = [
    _this.defaultItemExpo.fk_idcurrency.slice(0, 3),
    _this.defaultItemExpo.fk_idcurrency.slice(3, 6)
  ];
  let dat = new Date();
  dat.setMonth(dat.getMonth() + 3, dat.getDay());
  _this.defaultItemExpo.planned_expiration_date = dat;
  // CRUD: initiate default Hedge item
  _this.defaultItemHedge.fk_idcurrency = _this.allCurrencies[0].currency_name;
  _this.defaultItemHedge.fk_idcountry_currency = _this.defaultItemHedge.fk_idcurrency.slice(
    0,
    3
  );
  _this.defaultItemHedge.fk_idcountry_premium_currency = _this.defaultItemHedge.fk_idcurrency.slice(
    0,
    3
  );
  _this.leftRightCurrHedge = [
    _this.defaultItemHedge.fk_idcurrency.slice(0, 3),
    _this.defaultItemHedge.fk_idcurrency.slice(3, 6)
  ];
  dat = new Date();
  _this.defaultItemHedge.trade_date = dat;
  _this.defaultItemHedge.premium_value_date = dat;
  dat.setMonth(dat.getMonth() + 6, dat.getDay());
  _this.defaultItemHedge.fixing_date = dat;
  _this.defaultItemHedge.value_date = dat;

  // ======== ======== ======== ========
  _this.selectedPortfolios = [];
  companyPortfolioAsset(_this, step, resetPortfolio, fetch);

  // CRUD: initiate default item Expo and Hedge
  _this.editedItemExpo = Array.from([_this.defaultItemExpo])[0];
  _this.editedItemHedge = Array.from([_this.defaultItemHedge])[0];
}

export function setManagementInfoCommodities(
  _this,
  step = 0,
  resetPortfolio = true,
  fetch = true
) {
  _this.showLoadingExpoCommodities = true;
  _this.showLoadingComHedge = true;
  // CRUD: initiate default Expo item
  _this.defaultItemExpoCommodities.fk_idcommodity =
    _this.allCommodities[0].fk_idproduct;

  let dat = new Date();
  dat.setMonth(dat.getMonth() + 3, dat.getDay());
  _this.defaultItemExpoCommodities.date = dat;

  // CRUD: initiate default Hedge item
  _this.defaultItemHedgeCommodities.fk_idcommodity =
    _this.allCommodities[0].fk_idproduct;
  dat = new Date();
  _this.defaultItemHedgeCommodities.trade_date = dat;
  _this.defaultItemHedgeCommodities.premium_value_date = dat;
  dat.setMonth(dat.getMonth() + 6, dat.getDay());
  _this.defaultItemHedgeCommodities.fixing_date = dat;
  _this.defaultItemHedgeCommodities.value_date = dat;
  // ======== ======== ======== ========
  _this.selectedPortfolios = [];
  companyPortfolioAsset(_this, step, resetPortfolio, fetch);
  // CRUD: initiate default item Expo and Hedge
  _this.editedItemExpoCommodities = Array.from([
    _this.defaultItemExpoCommodities
  ])[0];
  _this.editedItemHedgeCommodities = Array.from([
    _this.defaultItemHedgeCommodities
  ])[0];
}

export function onAfterSaveCompany(_this) {
  _this.showCompanyPorfolioLoading = true;
  _this.companies = _this.$store.state.companies.all.items;
  _this.companyLen = _this.companies.length;
  setTimeout(() => (_this.showCompanyPorfolioLoading = false), 2000);
  setManagementInfo();
}

export function getHeadersExpo1() {
  return [
    {
      text: "Actions",
      value: "actions",
      width: "90px",
      sortable: false,
      must: "",
      explain: false,
      fld: false
    },
    {
      text: "Code",
      value: "pk",
      width: "50px",
      must: false,
      explain:
        "Alpha-numeric code used to uniquely identify the exposure in the Database. The system will replace the database record with matching code. If code does not exist, the system will create a new one.",
      fld: true
    },
    {
      text: "Portfolio",
      value: "fk_idportafolio",
      width: "125px",
      must: true,
      explain:
        "Portfolio name, a new portfolio will be created if there is no matching record.",
      fld: true
    },
    {
      text: "Rate",
      value: "fk_idcurrency",
      width: "70px",
      must: true,
      explain:
        "Currency pair ISO codes (three-letter alphabetic code for each currency), no divider. Examples: EURUSD, USDMXN.",
      fld: true
    },
    {
      text: "Exposure Type",
      value: "fk_idexposureoption",
      width: "180px",
      must: true,
      explain: "XXXXXXXXX.",
      fld: true
    },
    {
      text: "Notional",
      value: "notional",
      width: "125px",
      must: true,
      explain: "Notional amount, > 0.",
      fld: true
    },
    {
      text: "Currency",
      value: "fk_idcountry_currency",
      width: "70px",
      must: true,
      explain: "Currency ISO code (three-letter alphabetic code).",
      fld: true
    },
    {
      text: "Expected Cash Flow Date",
      value: "planned_expiration_date",
      width: "110px",
      must: true,
      explain: "Best cash flow´s date estimate, yyyy-mm-dd.",
      fld: true
    }
  ];
}
export function getHeadersExpo2() {
  return [
    {
      text: "Invoice Issue Date",
      value: "issue_date",
      width: "110px",
      must: false,
      explain:
        "Mandatory for accounts payable/receivable and for foreign asset/liability, yyyy-mm-dd.",
      fld: true
    },
    {
      text: "Rate at Issue Date",
      value: "rate_at_issue_date",
      width: "110px",
      must: false,
      explain:
        "Mandatory rate used when posting the accounts payable/receivable or foreign asset/liability, > 0.",
      fld: true
    },
    {
      text: "Invoice Due Date",
      value: "expiration_date",
      width: "110px",
      must: false,
      explain: "Mandatory for accounts payable/receivable. yyyy-mm-dd.",
      fld: true
    }
  ];
}
export function getHeadersExpo3() {
  return [
    {
      text: "Hedged Date",
      value: "hedged_date",
      width: "110px",
      must: false,
      explain: "yyyy-mm-dd.",
      fld: true
    },
    {
      text: "Exposure End Date",
      value: "sale_date",
      width: "110px",
      must: false,
      explain: "yyyy-mm-dd.",
      fld: true
    },
    {
      text: "Shipping Date",
      value: "shipping_date",
      width: "110px",
      must: false,
      explain: "yyyy-mm-dd.",
      fld: true
    },
    {
      text: "Hedged Asset",
      value: "hedge_asset",
      width: "125px",
      must: false,
      explain: "For cross hedging, register the hedged asset.",
      fld: true
    },
    {
      text: "End Product Hedged",
      value: "end_product",
      width: "125px",
      must: false,
      explain: "Name of your end product.",
      fld: true
    },
    {
      text: "Custom Name",
      value: "custom_name",
      width: "125px",
      must: false,
      explain: "Register the exposure with a custom name.",
      fld: true
    },
    {
      text: "Custom Id",
      value: "custom_id",
      width: "125px",
      must: false,
      explain: "Your custom Id, if required.",
      fld: true
    },
    {
      text: "Provider",
      value: "provider",
      width: "125px",
      must: false,
      explain: "Your provider´s name, if required.",
      fld: true
    },
    {
      text: "Client",
      value: "client",
      width: "125px",
      must: false,
      explain: "Your client´s name, if required.",
      fld: true
    },
    {
      text: "Plant",
      value: "plant",
      width: "125px",
      must: false,
      explain:
        "The plant you are supplying or where you are producing, if required.",
      fld: true
    },
    {
      text: "Comments",
      value: "comments",
      width: "300px",
      must: false,
      explain: false,
      fld: true
    },
    {
      text: "Settlement Rate",
      value: "rate_at_realized_expiration_date",
      width: "100px",
      must: false,
      explain:
        "Rate, > 0. Expired exposures only. If left empty, the system will use the settlement rate on the expected cash flow date and valuate the expired exposure automatically.",
      fld: true
    },
    {
      text: "Settlement PnL",
      value: "settlement_pnl",
      width: "125px",
      must: false,
      explain:
        "Amount payed or received in Your base currency. Expired exposures only. If left empty, the system will use the settlement rate on the expected cash flow date and valuate the expired exposure automatically.",
      fld: true
    }
  ];
}

export function getHeadersHedge1() {
  return [
    {
      text: "Actions",
      value: "actions",
      width: "90px",
      sortable: false,
      must: "",
      explain: false,
      fld: false
    },
    {
      text: "Code",
      value: "pk",
      width: "50px",
      must: false,
      explain:
        "Alpha-numeric code used to uniquely identify the hedge in the Database. The system will replace the database record with matching code. If code does not exist, the system will create a new one.",
      fld: true
    },
    {
      text: "Portfolio",
      value: "fk_idportafolio",
      width: "125px",
      must: true,
      explain:
        "Portfolio name, a new portfolio will be created if there is no matching record.",
      fld: true
    },
    {
      text: "Rate",
      value: "fk_idcurrency",
      width: "70px",
      must: true,
      explain:
        "Currency pair ISO codes (three-letter alphabetic code for each currency), no divider. Examples: EURUSD, USDMXN.",
      fld: true
    },
    {
      text: "Long|Short",
      value: "buy_sell",
      width: "70px",
      must: true,
      explain:
        "One of the following: LONG, SHORT, OFFSET LONG or OFFSET SHORT.",
      fld: true
    },
    {
      text: "Derivative",
      value: "derivative",
      width: "70px",
      must: true,
      explain: "One of the following: FUTURE, FORWARD, CALL or PUT.",
      fld: true
    },
    {
      text: "Derivative Type",
      value: "fk_idoptiontype",
      width: "110px",
      must: true,
      explain: "XXXXXXXXX.",
      fld: true
    },
    {
      text: "Settlement Type",
      value: "settlement_type",
      width: "180px",
      must: false,
      explain: "DELIVERABLE or NON DELIVERABLE.",
      fld: true
    },
    {
      text: "Trade Date",
      value: "trade_date",
      width: "110px",
      must: true,
      explain: "yyyy-mm-dd.",
      fld: true
    },
    {
      text: "Fixing Date",
      value: "fixing_date",
      width: "110px",
      must: true,
      explain: "Last fixing date for Asian Derivatives, yyyy-mm-dd.",
      fld: true
    },
    {
      text: "Value Date",
      value: "value_date",
      width: "110px",
      must: true,
      explain: "yyyy-mm-dd.",
      fld: true
    },
    {
      text: "Strike",
      value: "strike",
      width: "100px",
      must: true,
      explain: "Strike rate, > 0.",
      fld: true
    },
    {
      text: "Notional",
      value: "notional",
      width: "125px",
      must: true,
      explain: "Notional amount, > 0.",
      fld: true
    },
    {
      text: "Currency",
      value: "fk_idcountry_currency",
      width: "70px",
      must: true,
      explain: "Currency ISO code (three-letter alphabetic code).",
      fld: true
    },
    {
      text: "Premium",
      value: "premium",
      width: "125px",
      must: true,
      explain: "Total amount received (\u2265 0) or paid (< 0).",
      fld: true
    },
    {
      text: "Premium Currency",
      value: "fk_idcountry_premium_currency",
      width: "70px",
      must: true,
      explain:
        "Currency ISO code (three-letter alphabetic code) in which the premium is registered. Preferably in your base currency",
      fld: true
    },
    {
      text: "Premium Date",
      value: "premium_value_date",
      width: "110px",
      must: true,
      explain: "Premium value date, yyyy-mm-dd.",
      fld: true
    }
  ];
}
export function getHeadersHedge2() {
  return [
    {
      text: "Barrier",
      value: "barrier",
      width: "100px",
      must: false,
      explain: "For barrier options, > 0.",
      fld: true
    },
    {
      text: "Second Barrier",
      value: "barrier_2",
      width: "100px",
      must: false,
      explain: "For double barrier options, > 0.",
      fld: true
    },
    {
      text: "Asian Initial Date",
      value: "asian_fixing_start_date",
      width: "110px",
      must: false,
      explain: "Initial fixing date for Asian Derivatives, yyyy-mm-dd.",
      fld: true
    }
  ];
}
export function getHeadersHedge3() {
  return [
    {
      text: "Strategy",
      value: "fk_idcurrencystrategy_derivative",
      width: "210px",
      must: false,
      explain:
        "Please download list of all available strategies by clicking the link.",
      fld: true
    },
    {
      text: "Strategy Code",
      value: "strategy_code",
      width: "50px",
      must: false,
      explain:
        "Assign the same code to all derivatives that belong to the same strategy. That way we will be able to show you the aggregated results for each strategy.",
      fld: true
    },
    {
      text: "Spot Reference",
      value: "spot_reference",
      width: "100px",
      must: false,
      explain:
        "Register the observed spot rate when the hedge was executed, > 0.",
      fld: true
    },
    {
      text: "Hedged Date",
      value: "hedged_date",
      width: "110px",
      must: false,
      explain: "yyyy-mm-dd.",
      fld: true
    },
    {
      text: "Exposure End Date",
      value: "sale_date",
      width: "110px",
      must: false,
      explain: "yyyy-mm-dd.",
      fld: true
    },
    {
      text: "Shipping Date",
      value: "shipping_date",
      width: "110px",
      must: false,
      explain: "yyyy-mm-dd.",
      fld: true
    },
    {
      text: "Hedged Asset",
      value: "hedge_asset",
      width: "125px",
      must: false,
      explain: "For cross hedging, register the hedged asset.",
      fld: true
    },
    {
      text: "End Product Hedged",
      value: "end_product",
      width: "125px",
      must: false,
      explain: "Name of your end product.",
      fld: true
    },
    {
      text: "Custom Name",
      value: "custom_strategy_name",
      width: "125px",
      must: false,
      explain: "Register the strategy with a custom name.",
      fld: true
    },
    {
      text: "Custom Id",
      value: "counterpartys_id",
      width: "125px",
      must: false,
      explain: "Your custom Id, if required.",
      fld: true
    },
    {
      text: "Counterparty",
      value: "counterparty",
      width: "125px",
      must: false,
      explain: "Your counterpary´s name.",
      fld: true
    },
    {
      text: "Provider",
      value: "provider",
      width: "125px",
      must: false,
      explain: "Your provider´s name, if required.",
      fld: true
    },
    {
      text: "Client",
      value: "client",
      width: "125px",
      must: false,
      explain: "Your client´s name, if required.",
      fld: true
    },
    {
      text: "Plant",
      value: "plant",
      width: "125px",
      must: false,
      explain:
        "The plant you are supplying or where you are producing, if required.",
      fld: true
    },
    {
      text: "Comments",
      value: "comments",
      width: "300px",
      must: false,
      explain: false,
      fld: true
    },
    {
      text: "Settlement Rate",
      value: "settlement_rate",
      width: "100px",
      must: false,
      explain:
        "Rate, > 0. Expired derivatives only. If empty, the system will use the settlement rate on the fixing date and valuate the expired derivative automatically.",
      fld: true
    },
    {
      text: "Settlement Cash Flow",
      value: "settlement_pnl",
      width: "125px",
      must: false,
      explain:
        "Settlement amount in Your base currency. Expired derivatives only. If empty, the system will use the settlement rate on the fixing date and valuate the expired derivative automatically.",
      fld: true
    }
  ];
}

export function getHeadersComExpo1() {
  return [
    {
      text: "Actions",
      value: "actions",
      width: "90px",
      sortable: false,
      must: "",
      explain: false,
      fld: false
    },
    {
      text: "Code",
      value: "pk",
      width: "50px",
      must: false,
      explain:
        "Alpha-numeric code used to uniquely identify the exposure in the Database. The system will replace the database record with matching code. If code does not exist, the system create one.",
      fld: true
    },
    {
      text: "Portfolio",
      value: "fk_idportfolio",
      width: "125px",
      must: true,
      explain:
        "Portfolio name, a new portfolio will be created if there is no matching record.",
      fld: true
    },
    {
      text: "Commodity",
      value: "fk_idcommodity",
      width: "80px",
      must: true,
      explain: "Commodity name",
      fld: true
    },
    {
      text: "Quotation",
      value: "quotation",
      width: "80px",
      must: true,
      explain: "Price quotation",
      fld: true
    },
    {
      text: "Exposure Type",
      value: "fk_idcommodityexposureoption",
      width: "180px",
      must: true,
      explain: "XXXXXXXXX.",
      fld: true
    },
    {
      text: "Pricing method",
      value: "fk_idpricingmethod",
      width: "125px",
      must: true,
      explain:
        "Define if you are you buying/selling based on the spot price, or the average of previous or current week, month, etc.",
      fld: true
    },
    {
      text: "Date",
      value: "date",
      width: "110px",
      must: true,
      explain: "yyyy-mm-dd.",
      fld: true
    },
    {
      text: "Quantity",
      value: "quantity",
      width: "80px",
      must: true,
      explain: false,
      fld: true
    },
    {
      text: "Unit",
      value: "commodity_unit",
      width: "80px",
      must: true,
      explain: false,
      fld: true
    }
  ];
}
export function getHeadersComExpo2() {
  return [
    {
      text: "Futures Expiration Date",
      value: "contract_month_year",
      width: "80px",
      must: true,
      explain: "Futures expiration: month  year",
      fld: true
    },
    {
      text: "Continuation month",
      value: "continuation_month",
      width: "80px",
      must: true,
      explain: "Integer. Front Month = 1, next contracts = 2, 3, ...",
      fld: true
    }
  ];
}
export function getHeadersComExpo3() {
  return [
    {
      text: "Exposure End Date",
      value: "sale_date",
      width: "110px",
      must: false,
      explain: "yyyy-mm-dd.",
      fld: true
    },
    {
      text: "Shipping Date",
      value: "shipping_date",
      width: "110px",
      must: false,
      explain: "yyyy-mm-dd.",
      fld: true
    },
    {
      text: "Hedged Asset",
      value: "hedge_asset",
      width: "125px",
      must: false,
      explain: "For cross hedging, register the hedged asset.",
      fld: true
    },
    {
      text: "End Product Hedged",
      value: "end_product",
      width: "125px",
      must: false,
      explain: "Name of your end product.",
      fld: true
    },
    {
      text: "Custom Name",
      value: "custom_name",
      width: "125px",
      must: false,
      explain: "Register the exposure with a custom name.",
      fld: true
    },
    {
      text: "Custom Id",
      value: "custom_id",
      width: "125px",
      must: false,
      explain: "Your custom Id, if required.",
      fld: true
    },
    {
      text: "Port",
      value: "port",
      width: "125px",
      must: true,
      explain: "Port where the commodity will be traded.",
      fld: true
    },
    {
      text: "Provider",
      value: "provider",
      width: "125px",
      must: false,
      explain: "Your provider´s name, if required.",
      fld: true
    },
    {
      text: "Client",
      value: "client",
      width: "125px",
      must: false,
      explain: "Your client´s name, if required.",
      fld: true
    },
    {
      text: "Plant",
      value: "plant",
      width: "125px",
      must: false,
      explain:
        "The plant you are supplying or where you are producing, if required.",
      fld: true
    },
    {
      text: "Incoterm",
      value: "fk_idincoterms",
      width: "90px",
      must: true,
      explain: false,
      fld: true
    },
    {
      text: "Basis",
      value: "base",
      width: "90px",
      must: true,
      explain: "Basis: Local Cash Price - Futures Price",
      fld: true
    },
    {
      text: "Freight",
      value: "freight",
      width: "80px",
      must: true,
      explain: "",
      fld: true
    },
    {
      text: "Insurance",
      value: "insurance",
      width: "80px",
      must: false,
      explain: "",
      fld: true
    },
    {
      text: "Tariffs %",
      value: "tariffs",
      width: "80px",
      must: false,
      explain: "",
      fld: true
    },
    {
      text: "Bonus",
      value: "bonus",
      width: "80px",
      must: false,
      explain: "",
      fld: true
    },
    {
      text: "Bonus %",
      value: "percent_bonus",
      width: "80px",
      must: false,
      explain: "",
      fld: true
    },
    {
      text: "Comments",
      value: "comments",
      width: "300px",
      must: false,
      explain: false,
      fld: true
    },
    {
      text: "Settlement Price",
      value: "settlement_price",
      width: "100px",
      must: false,
      explain: "",
      fld: true
    },
    {
      text: "Settlement Cash Flow",
      value: "settlement_pnl",
      width: "100px",
      must: false,
      explain: "",
      fld: true
    }
  ];
}

export function getHeadersComHedge1() {
  return [
    {
      text: "Actions",
      value: "actions",
      width: "90px",
      sortable: false,
      must: "",
      explain: false,
      fld: false
    },
    {
      text: "Code",
      value: "pk",
      width: "50px",
      must: false,
      explain:
        "Alpha-numeric code used to uniquely identify the hedge in the Database. The system will replace the database record with matching code. If code does not exist, the system will create a new one.",
      fld: true
    },
    {
      text: "Portfolio",
      value: "fk_idportfolio",
      width: "125px",
      must: true,
      explain:
        "Portfolio name, a new portfolio will be created if there is no matching record.",
      fld: true
    },
    {
      text: "Commodity",
      value: "fk_idcommodity",
      width: "80px",
      must: true,
      explain: "Commodity name.",
      fld: true
    },
    {
      text: "Quotation",
      value: "quotation",
      width: "80px",
      must: true,
      explain: "Price quotation",
      fld: true
    },
    {
      text: "Long|Short",
      value: "buy_sell",
      width: "70px",
      must: true,
      explain:
        "One of the following: LONG, SHORT, OFFSET LONG or OFFSET SHORT.",
      fld: true
    },
    {
      text: "Derivative",
      value: "derivative",
      width: "70px",
      must: true,
      explain: "One of the following: FUTURE, FORWARD, CALL or PUT.",
      fld: true
    },
    {
      text: "Derivative Type",
      value: "fk_idoptiontype",
      width: "110px",
      must: true,
      explain: "XXXXXXXXX.",
      fld: true
    },
    {
      text: "Settlement Type",
      value: "settlement_type",
      width: "180px",
      must: true,
      explain: "DELIVERABLE or NON DELIVERABLE.",
      fld: true
    },
    {
      text: "Trade Date",
      value: "trade_date",
      width: "110px",
      must: true,
      explain: "yyyy-mm-dd.",
      fld: true
    },
    {
      text: "Fixing Date",
      value: "fixing_date",
      width: "110px",
      must: true,
      explain: "Last fixing date for Asian Derivatives, yyyy-mm-dd.",
      fld: true
    },
    {
      text: "Value Date",
      value: "value_date",
      width: "110px",
      must: true,
      explain: "yyyy-mm-dd.",
      fld: true
    },
    {
      text: "Strike",
      value: "strike",
      width: "100px",
      must: true,
      explain: "Strike Price, > 0.",
      fld: true
    },
    {
      text: "Quantity",
      value: "quantity",
      width: "80px",
      must: true,
      explain: "XXXXXXXXX.",
      fld: true
    },
    {
      text: "Unit",
      value: "commodity_unit",
      width: "80px",
      must: true,
      explain: "",
      fld: true
    },
    {
      text: "Premium",
      value: "premium",
      width: "80px",
      must: true,
      explain: "Total amount received (\u2265 0) or paid (< 0).",
      fld: true
    },
    {
      text: "Premium Date",
      value: "premium_value_date",
      width: "110px",
      must: true,
      explain: "Premium value date, yyyy-mm-dd.",
      fld: true
    }
  ];
}
export function getHeadersComHedge2() {
  return [
    {
      text: "Futures Date",
      value: "contract_month_year",
      width: "80px",
      must: true,
      explain: "Futures expiration: month  year",
      fld: true
    },
    {
      text: "Continuation month",
      value: "continuation_month",
      width: "80px",
      must: true,
      explain: "Integer. Front Month = 1, next contracts = 2, 3, ...",
      fld: true
    },
    {
      text: "Barrier",
      value: "barrier",
      width: "100px",
      must: false,
      explain: "For barrier options, > 0.",
      fld: true
    },
    {
      text: "Second Barrier",
      value: "barrier_2",
      width: "100px",
      must: false,
      explain: "For double barrier options, > 0.",
      fld: true
    },
    {
      text: "Asian Initial Date",
      value: "asian_fixing_start_date",
      width: "110px",
      must: false,
      explain: "Initial fixing date for Asian Derivatives, yyyy-mm-dd.",
      fld: true
    }
  ];
}
export function getHeadersComHedge3() {
  return [
    {
      text: "Strategy",
      value: "fk_idcommodity_strategy",
      width: "210px",
      must: false,
      explain:
        "Please download list of all available strategies by clicking the link.",
      fld: true
    },
    {
      text: "Strategy Code",
      value: "strategy_code",
      width: "50px",
      must: false,
      explain:
        "Assign the same code to all derivatives that belong to the same strategy. That way we will be able to show you the aggregated results for each strategy.",
      fld: true
    },
    {
      text: "Spot Reference",
      value: "spot_reference",
      width: "100px",
      must: false,
      explain:
        "Register the observed spot rate when the hedge was executed, > 0.",
      fld: true
    },
    {
      text: "Hedged Date",
      value: "hedged_date",
      width: "110px",
      must: false,
      explain: "yyyy-mm-dd.",
      fld: true
    },
    {
      text: "Exposure End Date",
      value: "sale_date",
      width: "110px",
      must: false,
      explain: "yyyy-mm-dd.",
      fld: true
    },
    {
      text: "Shipping Date",
      value: "shipping_date",
      width: "110px",
      must: false,
      explain: "yyyy-mm-dd.",
      fld: true
    },
    {
      text: "Hedged Asset",
      value: "hedge_asset",
      width: "125px",
      must: false,
      explain: "For cross hedging, register the hedged asset.",
      fld: true
    },
    {
      text: "End Product Hedged",
      value: "end_product",
      width: "125px",
      must: false,
      explain: "Name of your end product.",
      fld: true
    },
    {
      text: "Custom Name",
      value: "custom_strategy_name",
      width: "125px",
      must: false,
      explain: "Register the strategy with a custom name.",
      fld: true
    },
    {
      text: "Custom Id",
      value: "counterpartys_id",
      width: "125px",
      must: false,
      explain: "Your custom Id, if required.",
      fld: true
    },
    {
      text: "Counterparty",
      value: "counterparty",
      width: "125px",
      must: false,
      explain: "Your counterpary´s name.",
      fld: true
    },
    {
      text: "Port",
      value: "port",
      width: "125px",
      must: true,
      explain: "Port where the commodity will be traded.",
      fld: true
    },
    {
      text: "Provider",
      value: "provider",
      width: "125px",
      must: false,
      explain: "Your provider´s name, if required.",
      fld: true
    },
    {
      text: "Client",
      value: "client",
      width: "125px",
      must: false,
      explain: "Your client´s name, if required.",
      fld: true
    },
    {
      text: "Plant",
      value: "plant",
      width: "125px",
      must: false,
      explain:
        "The plant you are supplying or where you are producing, if required.",
      fld: true
    },
    {
      text: "Comments",
      value: "comments",
      width: "300px",
      must: false,
      explain: false,
      fld: true
    },
    {
      text: "Settlement Price",
      value: "settlement_rate",
      width: "100px",
      must: false,
      explain:
        "Price, > 0. Expired derivatives only. If empty, the system will use the settlement rate on the fixing date and valuate the expired derivative automatically.",
      fld: true
    },
    {
      text: "Settlement Cash Flow",
      value: "settlement_pnl",
      width: "100px",
      must: false,
      explain:
        "Settlement amount in Your base currency. Expired derivatives only. If empty, the system will use the settlement rate on the fixing date and valuate the expired derivative automatically.",
      fld: true
    }
  ];
}

export function getFirstCompany() {
  return [
    {
      pk_idcompany: 1,
      portfolios: [
        {
          pk_idportfolio: 1,
          fk_currency: ["EURUSD"],
          fk_idcommodity: [],
          portfolio_name: "NEW PORTFOLIO",
          created_at: "2020-01-01T10:10:00Z",
          show: true,
          fk_idcompany: 1
        }
      ]
    }
  ];
}

export function getDefaultItemExpo() {
  return {
    pk: "pending",
    edited: false,
    fk_idportafolio: "",
    fk_idcurrency: "EURUSD",
    fk_idexposureoption: "ACCOUNTS PAYABLE",
    notional: "1000000",
    fk_idcountry_currency: "USD",
    planned_expiration_date: "2020-12-24",
    rate_at_realized_expiration_date: "",
    settlement_pnl: "",
    issue_date: "",
    rate_at_issue_date: "",
    expiration_date: "",
    custom_name: "",
    provider: "",
    client: "",
    plant: "",
    comments: "",
    settlement_rate: ""
  };
}

export function getDefaultItemHedge() {
  return {
    pk: "pending",
    edited: false,
    fk_idportfolio: "",
    fk_idcurrency: "EURUSD",
    trade_date: "2021-10-12",
    fixing_date: "2021-10-12",
    value_date: "2021-10-12",
    derivative: "CALL",
    fk_idoptiontype: "EUROPEAN",
    buy_sell: "LONG",
    strike: "1",
    notional: "100000",
    fk_idcountry_currency: "USD",
    premium: "0",
    fk_idcountry_premium_currency: "EUR",
    premium_value_date: "2000-10-12",
    settlement_rate: "",
    settlement_pnl: "",
    fk_idcurrencystrategy_derivative: "LONG CALL",
    strategy_name: "CALL",
    strategy_position: "LONG",
    strategy_code: "",
    settlement_type: "NON DELIVERABLE",
    counterparty: "",
    custom_strategy_name: "",
    spot_reference: "",
    barrier: "",
    barrier_2: "",
    asian_fixing_start_date: ""
  };
}

export function getDefaultItemExpoCommodities() {
  return {
    pk: "pending",
    edited: false,
    fk_idportfolio: "",
    fk_idcommodity: "brent",
    fk_idcommodityexposureoption: "PURCHASE",
    fk_idpricingmethod: "SPOT",
    quantity: 1000,
    freight: "",
    date: "2021-03-15",
    insurance: "",
    continuation_month: "1",
    contract_month_year: "",
    settlement_pnl: "",
    settlement_price: "",
    issue_date: "",
    percent_bonus: "",
    bonus: "",
    custom_name: "",
    provider: "",
    client: "",
    plant: "",
    comments: "",
    settlement_rate: "",
    tariffs: "",
    fk_idincoterms: "",
    quotation: "USD/bbl",
    commodity_unit: "bbl",
    base: ""
  };
}

export function getDefaultItemHedgeCommodities() {
  return {
    pk: "pending",
    edited: false,
    fk_idportfolio: "",
    fk_idcommodity: "brent",
    trade_date: "2021-10-12",
    fixing_date: "2021-10-12",
    value_date: "2021-10-12",
    derivative: "CALL",
    fk_idoptiontype: "EUROPEAN",
    buy_sell: "LONG",
    strike: "1",
    premium: "0",
    premium_value_date: "2021-10-12",
    settlement_rate: "",
    settlement_pnl: "",
    contract_month_year: "",
    continuation_month: "1",
    strategy_name: "CALL",
    strategy_position: "LONG",
    fk_idcommodity_strategy: "LONG CALL",
    strategy_code: "CALL",
    settlement_type: "NON DELIVERABLE",
    counterparty: "",
    custom_strategy_name: "",
    spot_reference: "",
    barrier: "",
    barrier_2: "",
    asian_fixing_start_date: "",
    quantity: 1,
    quotation: "USD/bbl",
    commodity_unit: "bbl"
  };
}

export function getDefaultDataModelPreferences(_this) {
  const items = _this.$store.state.user_preferences.all?.items;
  const datamodel_choices = items?.datamodel_choices;
  if (!datamodel_choices || Object.keys(datamodel_choices).length === 0) {
    let choices = {
      selected_nav: 0,
      color_theme: false,
      selected_sheet: 0,
      selected_company: [],
      selected_portfolio:
        _this.$store.state.companies.all.items[0]?.portfolios[0],
      selected_currencies:
        _this.$store.state.companies.all.items[0]?.portfolios[0].fk_currency,
      selected_commodities:
        _this.$store.state.companies.all.items[0]?.portfolios[0].fk_idcommodity,
      selected_nav_asset: 0
    };
    if (items) {
      items.datamodel_choices = choices;
      saveUserPreferences(_this);
    }
    return { choices };
  } else {
    return { choices: datamodel_choices };
  }
}
